import { isBrandRefreshEnabled } from './brandRefresh';

/**
 * Use when storefrontImage is missing or fails to load — only when brand refresh is on.
 */
// eslint-disable-next-line import/no-unresolved, global-require
const STOREFRONT_FALLBACK_IMAGE = require('../images/storefront-fallback-brand-refresh.png');

export const getStorefrontImageSrc = storefrontImage => {
  if (storefrontImage) {
    return storefrontImage;
  }
  return isBrandRefreshEnabled() ? STOREFRONT_FALLBACK_IMAGE : storefrontImage || '';
};

/**
 * Swap a broken storefront <img> to the fallback once.
 * No-op when brand refresh is off (legacy keeps the broken/missing src).
 * @param {SyntheticEvent} event
 */
export const handleStorefrontImageError = event => {
  if (!isBrandRefreshEnabled()) {
    return;
  }
  const img = event && (event.currentTarget || event.target);
  if (!img || img.dataset.fallbackApplied === 'true') {
    return;
  }
  img.dataset.fallbackApplied = 'true';
  img.src = STOREFRONT_FALLBACK_IMAGE;
};

export default STOREFRONT_FALLBACK_IMAGE;
